export class GptSearchEnvironment {
  public static getName = () => 'gpt-search';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://api.benzinga.com/'),
  });
}
